<template>
<div class="arrange">
  <h2>
      <span class="no">
        {{index}}.
    </span>
    {{ question }}
  </h2>
  <draggable

      class="list-group"
      tag="div"
      v-model="list"
      v-bind="dragOptions"
      @start="started"
      @end="isDragging = false"
      dragClass="dragging-ticket"

  >
    <transition-group type="transition" name="flip-list" tag="ul">
      <li
          class="list-group-item"
          v-for="element in list"
          :key="element.order"
      >
      <span>
<!--          <i-->
<!--              :class="-->
<!--                element.fixed ? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin'-->
<!--              "-->
<!--              @click="element.fixed = !element.fixed"-->
<!--              aria-hidden="true"-->
<!--          ></i>-->

        <p v-for=" ans in element.name.answer" :key="ans"> {{ans}}</p>
      </span>
      </li>
    </transition-group>
  </draggable>
<small>{{hint}}</small>
  <button class="btn btn-primary" @click="answered" >
    Next
  </button>

</div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
name: "ArrangeComponents",
  props: {
    question: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    options: {
      type: Array,
    },
    hint: {
      type: String
    }

  },
  display: "Transition",
  order: 6,
  data() {
    return {
      list: this.options.map((name, index) => {
        return { name, order: index + 1 };
      })
    };
  },
  components: {
    draggable,
  },
  methods: {
    started(){
      this.isDragging = true


    },

    answered(){


        this.$emit('answered', {
          index: this.index,
          ans:this.list, ques: this.question
        })

    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    validate(){
      if(this.ans&&this.ans.length>0) return true
      return false
    }
  },
  created() {

  }
}
</script>

<style lang="scss" scoped>
small {
  margin-top: 8px;
  font-size: 12px;
  font-style: normal;
  font-weight: normal;
  display: block;
  padding-left: 26px;
  text-transform: capitalize;
  @media (max-width: 600px) {
    padding-left: 2px;
  }
}
.sortable-fallback{
  visibility:hidden;
}
.dragging-ticket{

  opacity: 1 !important;
  border-radius: 0px !important;
  background: #456bde !important;
  border: none !important;
  box-shadow: none !important;
  span{
    opacity: 1 !important;
    background: #456bde !important;
    border: none !important;
    box-shadow: none !important;
  }
}
h2 {
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 33px;
  color: #52595E;
  margin-bottom: 16px;
  max-width: 375px;
  position: relative;
}
.btn{
  margin-top: 33px;
  box-shadow: none;
  border-radius: 32px;
  text-transform: capitalize;
  letter-spacing:1px;
  padding: 10px 25px;
  margin-left: 26px;
  @media (max-width: 600px) {
    margin-left: auto;
    margin-right: auto;
    display: block;
  }
  &:hover{
    background: #557efb;
    box-shadow: 0 13px 27px 0 rgba(85, 126, 251, 0.75);
  }
  &::after,
  &::before{
    content: none
  }
}
.list-group{
  ul{
    max-width: 470px;
    width: 100%;
    padding-left: 26px;
    background: #F3F6F9;
    @media (min-width: 768px) {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;
      grid-gap: 12px;
    }
    @media (max-width: 600px) {
      padding-left: 0;
    }
    li{
      border-radius: 8px;
      background: none;
      border: none;
      padding: 0;
      height: unset;
      width: unset;
      //&.sortable-chosen,
      &.ghost{
      //  background: none;
       opacity: .8 !important;
      //  transform: rotate(5deg) !important;
      }
    }
    span{
      cursor: move;
      //height:50px;
      width: 100%;
      display: flex;
      flex-direction: column;
      background: #6a82fb;
      border: 2px solid #6a82fb;
      border-radius: 8px;
      font-style: normal;
      font-weight: normal;
      padding: 16px;
      //display: flex;
      //align-items: center;
      transition: all 0.2s ease-in-out;
      &:hover ,
      &:focus{
        background: #456bde;
      }
      &.active{
        background: #557EFB;
      }
      p{
        margin:0;
        font-size: 24px;
        line-height: 33px;
        color: #FFFFFF;
      }
    }
  }
}
</style>
